import { Typography } from "@material-ui/core"

export const IndexationAlert=()=>{
    return <Typography>No Steps Required</Typography>
}